import { render } from "./About.vue?vue&type=template&id=63a802de&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=63a802de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63a802de"

export default script